import { useState } from "react";
import { Eye, Heart, Lock, MessageCircleHeart } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const Row = ({ icon: Icon, title, children }) => (
  <div className="flex gap-3">
    <div className="w-9 h-9 shrink-0 rounded-full bg-mm-primary/10 text-mm-primary flex items-center justify-center"><Icon size={17} /></div>
    <div><div className="font-semibold">{title}</div><p className="text-sm text-mm-muted">{children}</p></div>
  </div>
);

// Shown to supporters until they tap "Got it"
export const SupporterWelcome = ({ token, name, welcomed }) => {
  const [open, setOpen] = useState(!welcomed);
  if (!open) return null;
  const done = () => { setOpen(false); api.post(`/supporters/view/${token}/welcomed`).catch((e) => logError("Welcome mark failed:", e)); };
  return (
    <section className="mm-card p-6 border-2 border-mm-primary/30 mm-fade-up" data-testid="supporter-welcome">
      <div className="text-4xl mb-2" aria-hidden>💜</div>
      <h2 className="text-2xl font-bold">Welcome, and thank you for being here</h2>
      <p className="text-mm-muted mt-1 mb-5">{name} chose you as someone they trust. Here's how this page works.</p>
      <div className="space-y-4">
        <Row icon={Eye} title="What you can see">Only what {name} chooses to share, like mood trends, streaks and their weekly summary. They can change this any time.</Row>
        <Row icon={Lock} title="What stays private">Their journal, chats with Mia and anything they haven't shared are never shown here.</Row>
        <Row icon={MessageCircleHeart} title="How to send a note">Write a few kind words in the note box below. It appears on {name}'s home screen, and they can reply or send a heart back.</Row>
        <Row icon={Heart} title="Little ways to help">Send a hug when they reach a streak, or a note before a harder day. Small and kind beats long and perfect.</Row>
      </div>
      <p className="text-xs text-mm-muted mt-5">If {name} is ever in danger, call 911 (US) or call/text 988 right away.</p>
      <button onClick={done} className="mm-btn mt-4" data-testid="supporter-welcome-done">Got it</button>
    </section>
  );
};
